import { ProductListProps } from "@made-people/blueprint-product-list";
import { FilterIcon } from "../../../assets/icons/FilterIcon";

/**
 * In this file you can specify default props for components that render,
 * which have been wrapped with withManagedProps
 */

export const ProductList: ProductListProps = {
  filter: {
    enabled: true,
  },
  layout: {
    spacing: {
      y: {
        initial: "lg",
        md: "2xl",
        lg: "2xl",
      },
    },
  },
  header: {
    templateProps: {
      isSticky: false,
      template: "montevideo",
      triggerIcon: FilterIcon,
      activeFilters: {
        enabled: true,
        showClearAll: true,
        buttonVariants: {
          style: "solid",
          color: "grey",
          rounded: "full",
        },
        clearButtonVariants: {
          style: "outline",
          color: "black",
          rounded: "full",
        },
      },
    },
  },

  loadMore: {
    indicators: ["seenProducts", "progressbar"],
    buttonVariants: {
      style: "solid",
      width: "full",
    },
    infiniteScroll: {
      enabled: false,
    },
  },
};
